import { render, staticRenderFns } from "./KanriInvoiceItemsView.vue?vue&type=template&id=4ee1c838&scoped=true&"
import script from "./KanriInvoiceItemsView.vue?vue&type=script&lang=ts&"
export * from "./KanriInvoiceItemsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee1c838",
  null
  
)

export default component.exports